module.exports = __webpack_public_path__ + "static/media/Nota Cúrcuma.ba8f6000.jpg";